import { render, staticRenderFns } from "./PinnedColumn.vue?vue&type=template&id=7f6efbc0&lang=pug&"
import script from "./PinnedColumn.vue?vue&type=script&lang=js&"
export * from "./PinnedColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports